<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Circumstances</h3>

      <MaritalStatusYN v-model="form.maritalStatusYN"/>
      <div v-if="form.maritalStatusYN" class="question-box with-arrow mt-32">
        <MaritalStatus v-model="form.maritalStatus"/>
      </div>

      <ChildrenGrandchildrenYN v-model="form.childrenGrandchildrenYN"/>
      <div v-if="form.childrenGrandchildrenYN" class="question-box with-arrow mt-32">
        <ChildrenGrandchildren v-model="form.childrenGrandchildren"/>
      </div>

      <BeneficiaryDiedYN v-model="form.beneficiaryDiedYN"/>
      <div v-if="form.beneficiaryDiedYN" class="question-box with-arrow mt-32">
        <BeneficiaryDied v-model="form.beneficiaryDied"/>
      </div>

      <BeneficiaryRelationshipYN v-model="form.beneficiaryRelationshipYN"/>
      <div v-if="form.beneficiaryRelationshipYN" class="question-box with-arrow mt-32">
        <BeneficiaryRelationship v-model="form.beneficiaryRelationship"/>
      </div>

      <SignificantAssetsYN v-model="form.significantAssetsYN"/>
      <div v-if="form.significantAssetsYN" class="question-box with-arrow mt-32">
        <SignificantAssets v-model="form.significantAssets"/>
      </div>

      <PropertyChangedYN v-model="form.propertyChangedYN"/>
      <div v-if="form.propertyChangedYN" class="question-box with-arrow mt-32">
        <PropertyChanged v-model="form.propertyChanged"/>
      </div>

      <BusinessStatusYN v-model="form.businessStatusYN"/>
      <div v-if="form.businessStatusYN" class="question-box with-arrow mt-32">
        <BusinessStatus v-model="form.businessStatus"/>
      </div>

      <MovedAbroadYN v-model="form.movedAbroadYN"/>
      <div v-if="form.movedAbroadYN" class="question-box with-arrow mt-32">
        <MovedAbroad v-model="form.movedAbroad"/>
      </div>

      <CharitableGiftsYN v-model="form.charitableGiftsYN"/>
      <div v-if="form.charitableGiftsYN" class="question-box with-arrow mt-32">
        <CharitableGifts v-model="form.charitableGifts"/>
      </div>

      <TrustsChangedYN v-model="form.trustsChangedYN"/>
      <div v-if="form.trustsChangedYN" class="question-box with-arrow mt-32">
        <TrustsChanged v-model="form.trustsChanged"/>
      </div>

      <GuardianChangedYN v-model="form.guardianChangedYN"/>
      <div v-if="form.guardianChangedYN" class="question-box with-arrow mt-32">
        <GuardianChanged v-model="form.guardianChanged"/>
      </div>

      <FinancialChangesYN v-model="form.financialChangesYN"/>
      <div v-if="form.financialChangesYN" class="question-box with-arrow mt-32">
        <FinancialChanges v-model="form.financialChanges"/>
      </div>
    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import MaritalStatusYN from "@/components/common/questionnaires/question/questions/amendment/MaritalStatusYN.vue";
import MaritalStatus from "@/components/common/questionnaires/question/questions/amendment/MaritalStatus.vue";
import ChildrenGrandchildrenYN
  from "@/components/common/questionnaires/question/questions/amendment/ChildrenGrandchildrenYN.vue";
import BeneficiaryDiedYN from "@/components/common/questionnaires/question/questions/amendment/BeneficiaryDiedYN.vue";
import BeneficiaryRelationshipYN
  from "@/components/common/questionnaires/question/questions/amendment/BeneficiaryRelationshipYN.vue";
import SignificantAssetsYN
  from "@/components/common/questionnaires/question/questions/amendment/SignificantAssetsYN.vue";
import PropertyChangedYN from "@/components/common/questionnaires/question/questions/amendment/PropertyChangedYN.vue";
import BusinessStatusYN from "@/components/common/questionnaires/question/questions/amendment/BusinessStatusYN.vue";
import MovedAbroadYN from "@/components/common/questionnaires/question/questions/amendment/MovedAbroadYN.vue";
import CharitableGiftsYN from "@/components/common/questionnaires/question/questions/amendment/CharitableGiftsYN.vue";
import TrustsChangedYN from "@/components/common/questionnaires/question/questions/amendment/TrustsChangedYN.vue";
import GuardianChangedYN from "@/components/common/questionnaires/question/questions/amendment/GuardianChangedYN.vue";
import FinancialChangesYN from "@/components/common/questionnaires/question/questions/amendment/FinancialChangesYN.vue";
import ChildrenGrandchildren
  from "@/components/common/questionnaires/question/questions/amendment/ChildrenGrandchildren.vue";
import BeneficiaryDied from "@/components/common/questionnaires/question/questions/amendment/BeneficiaryDied.vue";
import BeneficiaryRelationship
  from "@/components/common/questionnaires/question/questions/amendment/BeneficiaryRelationship.vue";
import SignificantAssets from "@/components/common/questionnaires/question/questions/amendment/SignificantAssets.vue";
import PropertyChanged from "@/components/common/questionnaires/question/questions/amendment/PropertyChanged.vue";
import BusinessStatus from "@/components/common/questionnaires/question/questions/amendment/BusinessStatus.vue";
import MovedAbroad from "@/components/common/questionnaires/question/questions/amendment/MovedAbroad.vue";
import CharitableGifts from "@/components/common/questionnaires/question/questions/amendment/CharitableGifts.vue";
import TrustsChanged from "@/components/common/questionnaires/question/questions/amendment/TrustsChanged.vue";
import GuardianChanged from "@/components/common/questionnaires/question/questions/amendment/GuardianChanged.vue";
import FinancialChanges from "@/components/common/questionnaires/question/questions/amendment/FinancialChanges.vue";

export default {
  name: 'NameStatusAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    MaritalStatusYN,
    MaritalStatus,
    ChildrenGrandchildrenYN,
    BeneficiaryDiedYN,
    BeneficiaryRelationshipYN,
    SignificantAssetsYN,
    PropertyChangedYN,
    BusinessStatusYN,
    MovedAbroadYN,
    CharitableGiftsYN,
    TrustsChangedYN,
    GuardianChangedYN,
    FinancialChangesYN,
    ChildrenGrandchildren,
    BeneficiaryDied,
    BeneficiaryRelationship,
    SignificantAssets,
    PropertyChanged,
    BusinessStatus,
    MovedAbroad,
    CharitableGifts,
    TrustsChanged,
    GuardianChanged,
    FinancialChanges,
  },
  data() {
    return {
      label: 'Circumstances', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
